import React from 'react';

import {Cell, Row} from '@pb/kit-component-table';
import Typography from '@pb/kit-component-typography';

import {
    migrationStepperSectionHeader,
} from './migration-stepper.module.styl';

export type ComparisonRow = {
    left: string,
    right: string,
};

type Props = {
    title: string,
    rows: ComparisonRow[],
    startIdx: number,
    endIdx: number,
};

export const ComparisonSection = ({
    title,
    rows,
    startIdx,
    endIdx,
}: Props) => {
    const totalRows = rows.length;

    const visibleRowCount = totalRows > 0
        ? Math.min(endIdx, totalRows) - startIdx
        : 0;

    // Section falls completely outside the current page — hide it.
    // Empty sections (totalRows === 0) use startIdx/endIdx to decide
    // whether their placeholder row belongs on this page.
    if (totalRows === 0 && (startIdx > 0 || endIdx <= 0)) {
        return null;
    }

    if (totalRows > 0 && (startIdx >= totalRows || visibleRowCount <= 0)) {
        return null;
    }

    return (
        <>
            <Row showZebra={false}>
                <Cell colSpan={2} className={migrationStepperSectionHeader}>
                    <Typography fontWeight="semi-bold">{title}</Typography>
                </Cell>
            </Row>
            {totalRows === 0 && (
                <Row showZebra={false}>
                    <Cell>--</Cell>
                    <Cell>--</Cell>
                </Row>
            )}
            {Array.from({length: visibleRowCount}).map((_, i) => {
                const rowIdx = startIdx + i;
                const row = rows[rowIdx];
                return (
                    <Row key={rowIdx} showZebra={i % 2 === 0}>
                        <Cell>{row.left || '--'}</Cell>
                        <Cell>{row.right || '--'}</Cell>
                    </Row>
                );
            })}
        </>
    );
};
